export default __webpack_public_path__ + "static/media/srt-fail.fbb265ec.svg";